var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 38,
    viewBox: "0 0 49 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.497 16.5884V37.6127H0.472656V16.2881C0.472656 1.87142 13.9883 0.0693359 13.9883 0.0693359L15.7904 4.2742C15.7904 4.2742 9.78342 5.17524 8.58203 9.98079C7.38064 13.585 9.78342 16.5884 9.78342 16.5884H21.497ZM48.5282 16.5884V37.6127H27.5039V16.2881C27.5039 1.87142 41.0195 0.0693359 41.0195 0.0693359L42.8216 4.2742C42.8216 4.2742 36.8147 5.17524 35.6133 9.98079C34.4119 13.585 36.8147 16.5884 36.8147 16.5884H48.5282Z",
    fill: "#44484F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteFill);
export default __webpack_public_path__ + "static/media/quoteFill.5887a381115fc841dc1e855c069f97e3.svg";
export { ForwardRef as ReactComponent };